import Embed from '@editorjs/embed';
import Table from '@editorjs/table';
import List from '@editorjs/list';
import Warning from '@editorjs/warning';
import Header from '@editorjs/header';
import Quote from '@editorjs/quote';
import Marker from '@editorjs/marker';
import CheckList from '@editorjs/checklist';
import SimpleImage from '@editorjs/simple-image';

// import LinkTool from '@editorjs/link';
// import Image from '@editorjs/image';

export const EDITOR_JS_TOOLS = {
    embed: Embed,
    table: Table,
    marker: Marker,
    list: List,
    warning: Warning,
    header: Header,
    quote: Quote,
    checklist: CheckList,
    simpleImage: SimpleImage,
}
